<template>
  <div class="search-page-button">
    <div @click.capture="showDetailSearch = true">{{ label }}</div>
    <transition name="fade" mode="out-in">
      <popup v-if="showDetailSearch">
        <detailSelect
          :item="areaList"
          :value="areaId"
          @cancel="showDetailSearch = false"
          @change="(area_id) => { showDetailSearch = false; handleChange(area_id) }"
        />
      </popup>
    </transition>
  </div>
</template>
<script>
import { getArea } from '@/api/shop'
import DetailSelect from '@/components/search/DetailSelect'
import Popup from '@/components/search/Popup'

export default {
  emits: ['change-area'],
  components: {
    DetailSelect,
    Popup
  },
  props: {
    areaId: {
      type: Number,
      default() {
        return 0 // 0:全部
      }
    }
  },
  data() {
    return {
      showDetailSearch: false,
      areaList: []
    }
  },
  computed: {
    // areaId 選擇的項目 //
    label() {
      const area = this.find(this.areaId)
      return area === undefined ? '' : area.name
    },
  },
  created() {
    this.getAreaList()
  },
  methods: {
    handleChange(area_id) {
      this.$emit('change-area', area_id)
    },
    async getAreaList() {
      try {
        const { data } = await getArea()
        this.areaList = [
          {
            name: this.$langt('全部'),
            area_id: 0,
            regions: []
          },
          ...data.data
        ]
      } catch (error) {
        // error
      }
    },
    // 從 area_id 計算出選擇的 areaList 中的項目。沒有找到回傳 undefined //
    find(area_id) {
      if (area_id === 0) {
        return { area_id: 0, name: this.$langt('全部') }
      }
      for (let i = 0; i < this.areaList.length; i++) {
        if (this.areaList[i].area_id === area_id) {
          return this.areaList[i]
        }
        if (this.areaList[i].regions) {
          const result = this.areaList[i].regions.find(e => e.area_id === area_id)
          if (result !== undefined) {
            return result
          }
        }
      }
      return undefined
    }
  }
}
</script>

<style scoped lang="scss">
@import 'assets/scss/common.scss';

.search-page-button {
  width: 100%;
  background: url(~@/assets/images/arrow-down.svg) no-repeat calc(100% - 15px) center;
  background-size: 10px;
  border: none;
  color: white;
  background-color: var(--main-color);
  border-radius: 3rem 0rem 0rem 3rem;
  width: 100%;
  height: 100%;
  line-height: 2.2rem;
  text-align: center;
  cursor: pointer;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s ease;
}

.fade-leave {}

.fade-leave-active {
  transition: opacity 0.2s ease;
  opacity: 0;
}
</style>
